import { render, staticRenderFns } from "./PublishedProductsView.vue?vue&type=template&id=df887400"
import script from "./PublishedProductsView.vue?vue&type=script&lang=js"
export * from "./PublishedProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports